import React, { Component } from 'react';
import Chapters from '../Chapters'
import ChapterContent from '../../containers/ChapterContent/ChapterContent';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
    getChapterList,
    select,
    selectItem,
    getTest,
    openNavBar,
    setChapter, setCurrentElement
} from '../../actions/index';
import './Content.css';
import Fab from '@material-ui/core/Fab';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Zoom from '@material-ui/core/Zoom';



class Content extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.chapters.chaptersList[0]) {
            let courseName = this.props.chapters.chaptersList[0].text.split(":")[1];
            if (!document.title.includes(courseName)) {
                document.title += courseName;
            }
        }
        if (this.props.chapters.chaptersList !== prevProps.chapters.chaptersList) {
            if (this.props.chapters.chaptersList[0]
                && this.props.chapters.chaptersList[0].last_visited) {
                let { course_id, item_id, node_id } = this.props.chapters.chaptersList[0].last_visited;
                console.log("This is a path", this.props.location.pathname);
                node_id && !this.props.location.pathname.includes('nodes') ? item_id && !this.props.location.pathname.includes('item') ? this.props.history.push(course_id + '/nodes/' + node_id + '/item/' + item_id) : this.props.history.push('nodes/' + node_id) : '';
            }
            let course_id = this.props.match.params.course_pk;
            let node_id = this.props.match.params.node_id;
            let item_id = this.props.match.params.item_id;
            if (course_id && !node_id && !item_id && this.props.chapters.chaptersList[0] && this.props.chapters.chaptersList[0].nodes) {
                this.props.select(this.props.chapters.chaptersList[0].nodes[0]);
            }
            let array = [];
            if (this.props.chapters.chaptersList.length > 0) {
                this.getAllElement(this.props.chapters.chaptersList, array);
            }
        }

        let drawer = document.querySelector('.book-titles-wrapper_open');

        if (drawer) {
            const headerEl = document.querySelector('header');

            if (headerEl) {
                drawer.style.marginTop = headerEl.clientHeight + 'px';
            }

            var active = document.querySelector(".paragraph-current.active");;

            if (active) {
                active.scrollIntoView();
            }

        }

        let container = document.querySelector('.container');
        let player = document.querySelector('.video-player-parent');

        if (player) {
            const height = container.clientWidth / 1.77;
            player.style.height = height + 'px';
        }

       
    }

    getAllElement = (chapters, array) => {
        let pathArray = window.location.href.split("/");
        let courseId = window.location.href.includes('course_approve') ? pathArray[pathArray.indexOf('course_approve') + 1] : pathArray[pathArray.indexOf("course") + 1];
        for (let i = 0; i < chapters.length; i++) {
            let parentNodeId = chapters[i].node_parent_id;
            if (chapters[i].items) {
                for (let j = 0; j < chapters[i].items.length; j++) {
                    chapters[i].items[j].nodeId = chapters[i].node_id;
                    chapters[i].items[j].node_id = chapters[i].node_id;
                    chapters[i].items[j].courseId = courseId;
                    chapters[i].items[j].parentNodeId = parentNodeId;
                    array.push(chapters[i].items[j]);
                }
            } else {
            }
            if (chapters[i].nodes) {
                this.getAllElement(chapters[i].nodes, array)
            }
            this.getAllElement(chapters[i], array);
        }

        this.props.setChapter(array);
    };

    componentDidMount() {
        if (this.props.location !== undefined) {
            let course_pk = this.props.match.params.course_pk;
            if (course_pk !== undefined) {
                this.props.getChapterList(course_pk, this.props.approved);
            }
        }

        const headerEl = document.querySelector('header');
        const content = document.querySelector('.main-content');

        content.style.marginTop = headerEl.clientHeight + 'px';




    }


    iterate(chapters, node_id, item_id) {
        for (let i = 0; i < chapters.length; i++) {
            if (chapters[i].node_id === parseInt(node_id)) {
                this.props.select(chapters[i]);
                if (chapters[i].items.length > 0) {
                    if (!item_id) {
                        this.props.selectItem(chapters[i].items[0]);
                    }
                }
                for (let j = 0; j < chapters[i].items.length; j++) {
                    if (chapters[i].items[j].item_id === parseInt(item_id)) {
                        if (chapters[i].items[j].content_type === 4) {
                            this.props.getTest(chapters[i].items[j].item_pk)
                        } else {
                            this.props.selectItem(chapters[i].items[j]);
                        }
                    }
                }
            } else {
                this.iterate(chapters[i].nodes, node_id, item_id);
            }
        }
    }

    onOpenNavBar(e) {
        e.preventDefault();
        e.stopPropagation();
        this.props.closeButton(this.props.buttonClosed);

    }

    render() {
        let course_id = this.props.match.params.course_pk;
        let node_id = this.props.match.params.node_id;
        let item_id = this.props.match.params.item_id;

        if (node_id) {
            this.iterate(this.props.chapters.chaptersList, node_id, item_id);
        }

        if (course_id && !node_id && !this.props.navigation.previousItem && !this.props.navigation.nextItem) {
            this.props.previous(null, null, this.props.allElements);
        } else if (node_id && !item_id && !this.props.navigation.previousItem && !this.props.navigation.nextItem) {
            this.props.previous(node_id, null, this.props.allElements);
        } else if (node_id && item_id && !this.props.navigation.previousItem && !this.props.navigation.nextItem) {
            this.props.previous(node_id, item_id, this.props.allElements);
        }


        let bookWrapper = 'book-titles-wrapper';
        let asideMenuButton = 'aside-menu-button';
        if (!this.props.buttonClosed) {
            bookWrapper = 'book-titles-wrapper_open';
            asideMenuButton = 'aside-menu-button_open';

        }


        return (
            <div
                id="main_content"
            >

                <div
                    className={bookWrapper}
                >
                    <div className="book-titles-background"
                    >
                        <Chapters
                            chapters={this.props.chapters}
                            content={this.props.active_item}
                        />
                    </div>
                    <Zoom class="scroll-top-btn" >
                        <div role="presentation">
                            <Fab color="secondary" size="small"
                                onClick={e => {
                                    e.preventDefault();
                                    e.stopPropagation();

                                    var elmnt = document.getElementById("content-top");


                                    elmnt.scrollIntoView({
                                        behavior: 'smooth'
                                    });

                                }}
                                aria-label="scroll back to top">
                                <KeyboardArrowUpIcon />
                            </Fab>
                        </div>
                    </Zoom>
                </div>
                {/* <div className="aside-menu-button-wrapper" onClick={this.onOpenNavBar.bind(this)}>
                    <div
                        className={asideMenuButton}
                    >
                        <div id="hexagon">
                            <p>
                                содержание
                            </p>
                        </div>
                    </div>
                </div> */}
                <div className="main-content-wrapper">
                    <div className="container"
                    >
                        <div
                            style={{
                                width: "100%",
                                height: '100%'
                            }}
                        >
                            <ChapterContent path={this.props.match.params} cont={this.props.active_item} />
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}


function mapStateToProps(state) {
    return {
        chapters: state.chapters,
        chapter: state.active,
        buttonClosed: state.buttonClosed,
        allElements: state.allElements,
        navigation: state.navigation,
        domainName: state.domainReducer,
        approved: state.approved,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            getChapterList: getChapterList,
            select: select,
            selectItem: selectItem,
            getTest: getTest,
            closeButton: openNavBar,
            setChapter: setChapter,
            previous: setCurrentElement,
        }, dispatch
    )
}

export default connect(mapStateToProps, mapDispatchToProps)(Content);




// WEBPACK FOOTER //
// ./src/components/content/Content.js